import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { forkJoin } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { TraductionService } from '../../services/traduction.service';
import { ModaleResultatComponent } from '../modale-resultat/modale-resultat.component';

@Component({
  selector: 'app-reinit-mot-de-passe',
  templateUrl: './reinit-mot-de-passe.component.html',
  styleUrls: ['./reinit-mot-de-passe.component.scss'],
  standalone: false
})
export class ReinitMotDePasseComponent {
  password: string;
  confirmPassword: string;
  mdpRequis = false;
  mdpLongMini = false;
  mdpDifferents = false;
  tokenInvalide = false;
  demandeValide = true;
  id: string;
  code: string;
  modalRef: BsModalRef;
  username: string;

  constructor(private readonly http: HttpService, private readonly traductionService: TraductionService, private readonly route: ActivatedRoute, private readonly modalService: BsModalService, private readonly router: Router,
    private readonly fonctionsService: FonctionsService) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.id = params.params['id'];
      this.code = params.params['code'];
    });
    let requetes = [this.http.get<string>('Users/' + this.id + '/language'),
    this.http.get<string>('Users/' + this.id + '/username')];
    forkJoin(requetes).subscribe(resultat => {
      this.traductionService.changerLangue(resultat[0]);
      this.username = resultat[1];
    });
  }

  onSubmit() {
    this.demandeValide = true;
    if (this.validationFormulaire()) {
      this.fonctionsService.loading_screen(true);
      let body = { Id: this.id, Code: this.code, MotDePasse: this.password };
      this.http.post('Authentication/ResetPassword', body).subscribe(resultat => {
        this.fonctionsService.loading_screen(false);
        if (resultat['succeeded']) {
          this.traductionService.translate.get(['REINIT_MOT_DE_PASSE.MODALE_TITRE_REUSSIE', 'REINIT_MOT_DE_PASSE.MODALE_MESSAGE_REUSSIE']).subscribe(traduction => {
            const initialState = {
              titre: traduction['REINIT_MOT_DE_PASSE.MODALE_TITRE_REUSSIE'],
              resultat: traduction['REINIT_MOT_DE_PASSE.MODALE_MESSAGE_REUSSIE']
            };
            this.modalRef = this.modalService.show(ModaleResultatComponent, { initialState });
            this.modalRef.content.event.subscribe(() => {
              this.router.navigate(['login']);
            });
          });
        } else {
          this.demandeValide = false;
          if (resultat['errors'][0]['code'] === 'InvalidToken')
            this.tokenInvalide = true;
        }
      }, error => {
        this.demandeValide = false;
        this.fonctionsService.loading_screen(false);
      });
    }
  }

  validationFormulaire() {
    this.mdpRequis = this.password === null || this.password === undefined || this.password.trim() === '';
    this.mdpLongMini = !this.mdpRequis && this.password.length < 10;
    this.mdpDifferents = this.password !== this.confirmPassword;

    return !this.mdpRequis && !this.mdpLongMini && !this.mdpDifferents;
  }
}
